
import axios from 'axios'
import authConfig from './authh'
// import { useAuth } from 'src/hooks/useAuth'
// import React, { Component } from 'react';
// import { createContext, useEffect, useState } from 'react'



export const apiUnlockedPrm = async (lnk, prm) => {
  try {
    return axios({
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      url: authConfig.serviceAdress + authConfig.unLocked + lnk,
      data: new URLSearchParams(Object.entries(
        {
          lisans: JSON.stringify(lic()),
          prmdata: JSON.stringify(prm)
        })).toString()
    })
      .then((res) => res);
  }
  catch (error) {
    apiLog(error, "M.apiUnlocked")
    return null;
  }
}


export const apiLockedPrm = async (lnk, prm) => {
  try {
    // var app = express(); 
    // var cors = require('cors');
    // app.use(cors({origin: true, credentials: true}));

    const storedToken = window.localStorage.getItem(authConfig.storageTokenKeyName)
    if (storedToken) {
      return axios
        .post(authConfig.serviceAdress + authConfig.locked + lnk,
          require('querystring').stringify({
            "lisans": JSON.stringify(lic()),
            "prmdata": JSON.stringify(prm),
          }),
          {
            headers: {
              'Accept': 'application/json',
              'Origin': window.location.origin,
              'Content-Type': 'application/x-www-form-urlencoded',
              'Authorization': authConfig.tokenType + ' ' + storedToken
            }
          })
        .then((res) => res.data)
    }
  }
  catch (error) {
    apiLog(error, "M.apiLockedPrm")
    return null;
  }
}



// export const apiFLocked = async (lnk) => {
//   try {

//     // var app = express(); 
//     // var cors = require('cors');
//     // app.use(cors());
//     const storedToken = window.localStorage.getItem(authConfig.storageTokenKeyName)
//     if (storedToken) {
//        fetch(authConfig.serviceAdress + authConfig.locked + lnk,
//         {
//           body: require('querystring').stringify({
//             "lisans": JSON.stringify(lic()),
//           }),
//           method: 'POST',
//           headers: {
//             'Accept': 'application/json',
//             'Content-Type': 'application/x-www-form-urlencoded',
//             'Authorization': authConfig.tokenType + ' ' + storedToken
//           }
//         })
//         .then(res => res.data)
//     }
//   }
//   catch (error) {
//     apiLog(error, "M.apiLocked")
//     console.log(error.toString())
//     return null;
//   }
// }


export const apiLocked = async (lnk,prm) => {
  try {

    // var app = express(); 
    // var cors = require('cors');
    // app.use(cors());
    const storedToken = window.localStorage.getItem(authConfig.storageTokenKeyName)
    if (storedToken) {
      return axios.post(authConfig.serviceAdress + authConfig.locked + lnk,
        require('querystring').stringify({
          "lisans": JSON.stringify(lic()),
          "prmdata": JSON.stringify(prm),
        }),
        {
          headers: {
            'Accept': 'application/json',
             'Origin': window.location.origin,
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': authConfig.tokenType + ' ' + storedToken
          }
        })
        .then(res => res.data)
    }
  }
  catch (error) {
    apiLog(error, "M.apiLocked")
    console.log(error.toString())
    return null;
  }
}


export const apiLog = (detail, data) => {
  try {
    axios({
      method: 'post',
      headers: {
         'Origin': window.location.origin,
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      url: authConfig.serviceAdress + authConfig.unLocked + "LogEkle",
      data: new URLSearchParams(Object.entries(
        {
          lisans: JSON.stringify(lic()),
          prmdata: JSON.stringify({ LogType: 60, Detay: detail, Data: data })
        })).toString()
    })
      .then((res) => res);
  } catch (error) {
    console.log(error);
  }
}

export const lic = () => {


  const storedToken = window.localStorage.getItem(authConfig.storageTokenKeyName)
  const userId = window.localStorage.getItem(authConfig.storageUserIdKeyName)



  return {
    AppVersiyon: "tr",
    Cokid: "",
    TokenKey: storedToken,
    UserId: userId,
  };
}